import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(venueShorthandOnEnterSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call } from 'redux-saga/effects';
import { venueByIdV2 } from 'redux/saga/entities/bound';
export function venueShorthandOnEnterSaga(client, nextState, replaceState) {
  var venue;
  return regeneratorRuntime.wrap(function venueShorthandOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(fetchEntityIfNeeded, venueByIdV2, [client, nextState.params.venueId]);

        case 2:
          venue = _context.sent;

          if (!venue) {
            _context.next = 6;
            break;
          }

          _context.next = 6;
          return call(replaceState, {
            pathname: "/studios/".concat(venue.alias),
            state: {
              status: 301
            }
          });

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}